import { render, staticRenderFns } from "./CommonLocalBusinessSchemaComponent.vue?vue&type=template&id=5e68553f"
import script from "./CommonLocalBusinessSchemaComponent.vue?vue&type=script&lang=js"
export * from "./CommonLocalBusinessSchemaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports